import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Slider = ({ sliderState, handleSlider, title, id, disabled }) => (
    <div
        className={classNames(
            'sliderInfo',
            `${id}Slider`,
            disabled && 'sliderInfo_disabled'
        )}
    >
        <span className="sliderInfo__title">
            { title }
        </span>
        <label className="slider" htmlFor={id}>
            <input
                className="sliderInput"
                type="checkbox"
                checked={sliderState}
                onChange={handleSlider}
                id={id}
                disabled={disabled}
            />
            <span className="slider__trigger" />
        </label>
    </div>
);

Slider.propTypes = {
    sliderState: PropTypes.bool,
    handleSlider: PropTypes.func,
    title: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.string,
};

export default Slider;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/Slider.jsx